export const kpis = [
  {
    id: 'balance',
    label: 'Account Balance',
    value: 19892,
    format: 'currency',
    delta: 4.3,
    trend: [12, 14, 13, 16, 18, 17, 19.9],
  },
  {
    id: 'ytd',
    label: 'Year-to-Date Contribution',
    value: 4000,
    format: 'currency',
    delta: 8.1,
    trend: [2.1, 2.4, 2.9, 3.2, 3.6, 3.8, 4],
  },
  {
    id: 'interest',
    label: 'Total Interest Earned',
    value: 1892,
    format: 'currency',
    delta: 2.6,
    trend: [1.2, 1.3, 1.5, 1.6, 1.7, 1.8, 1.892],
  },
  {
    id: 'goal',
    label: 'Goal Achieved',
    value: 59,
    format: 'percent',
    delta: -1.2,
    trend: [52, 54, 55, 57, 58, 60, 59],
  },
];

export const transactions = [
  { id: 1, type: 'withdrawal', description: 'Transfer to Bank ••1183', amount: 20.0, date: '2026-06-24' },
  { id: 2, type: 'deposit', description: 'Payroll Contribution', amount: 320.5, date: '2026-06-21' },
  { id: 3, type: 'withdrawal', description: 'Transfer to Bank ••1183', amount: 35.5, date: '2026-06-16' },
  { id: 4, type: 'deposit', description: 'Employer Match', amount: 160.0, date: '2026-06-12' },
  { id: 5, type: 'withdrawal', description: 'Advisory Fee', amount: 12.75, date: '2026-06-08' },
  { id: 6, type: 'deposit', description: 'Payroll Contribution', amount: 320.5, date: '2026-06-07' },
  { id: 7, type: 'withdrawal', description: 'Transfer to Bank ••1183', amount: 48.2, date: '2026-05-29' },
  { id: 8, type: 'deposit', description: 'Dividend Reinvestment', amount: 64.18, date: '2026-05-22' },
];

export const retirement = {
  startYear: 2056,
  goal: 300000,
  goalAchievedPct: 59,
  estMonthlyIncome: 300,
};

export const contributionOvertime = {
  labels: ['20', '25', '30', '35', '40', '60', '65'],
  data: [50, 60, 80, 100, 200, 250, 300],
};

export const peerFilters = {
  age: {
    options: ['Under 30', '30–40', '40–50', '50+'],
    values: { 'Under 30': 30, '30–40': 48, '40–50': 62, '50+': 74 },
    color: '#6366f1',
  },
  salary: {
    options: ['K20–K30', 'K30–K50', 'K50–K80', 'K80+'],
    values: { 'K20–K30': 38, 'K30–K50': 45, 'K50–K80': 57, 'K80+': 71 },
    color: '#10b981',
  },
  gender: {
    options: ['Male', 'Female', 'Non-binary'],
    values: { Male: 55, Female: 61, 'Non-binary': 58 },
    color: '#f59e0b',
  },
};

export const retirementStrategy = {
  employeeContributionPct: 8.4,
  interestRatePct: 5,
  progress: [
    { id: 'employee', description: 'Employee Contribution', progress: 70 },
    { id: 'age', description: 'Retirement Age', progress: 80 },
  ],
};

export const newsItems = [
  { id: 1, title: 'Retirement Planning Tips', category: 'Retirement', date: '2026-06-28', summary: 'Learn how to maximize your retirement savings with these expert tips for the second half of the year.' },
  { id: 2, title: 'Market Update: Q2 Wrap-Up', category: 'Markets', date: '2026-06-26', summary: 'Stocks rise as investors remain optimistic about economic growth heading into the back half of 2026.' },
  { id: 3, title: 'New 401(k) Rules', category: 'Regulation', date: '2026-06-24', summary: 'Recent changes to 401(k) regulations could impact your savings strategy starting next quarter.' },
  { id: 4, title: 'How to Catch Up After 50', category: 'Retirement', date: '2026-06-19', summary: 'Catch-up contributions can meaningfully accelerate your timeline if you started saving late.' },
  { id: 5, title: 'Diversification in a Volatile Market', category: 'Markets', date: '2026-06-14', summary: 'Why spreading risk across asset classes matters more than ever this year.' },
  { id: 6, title: 'Understanding Employer Match', category: 'Education', date: '2026-06-10', summary: 'A plain-English breakdown of how employer matching works and how to capture every dollar.' },
];

export const accounts = [
  { id: 1, title: '401(k) Plan', type: 'Retirement', desc: 'Your main retirement savings account.', balance: 14820.32 },
  { id: 2, title: 'Roth IRA', type: 'Retirement', desc: 'Individual Retirement Account for extra savings.', balance: 3210.5 },
  { id: 3, title: 'Emergency Fund', type: 'Savings', desc: 'For unexpected expenses and peace of mind.', balance: 1500.0 },
  { id: 4, title: 'Health Savings Account', type: 'Health', desc: 'Tax-advantaged medical savings account.', balance: 842.18 },
  { id: 5, title: 'Brokerage Account', type: 'Investing', desc: 'Taxable account for general investing.', balance: 6120.91 },
  { id: 6, title: 'Education Fund (529)', type: 'Savings', desc: "Set aside for a dependent's education costs.", balance: 2390.0 },
];

export const userProfile = {
  name: 'Mike Donovan',
  email: 'mike@email.com',
  memberSince: '2018',
  plan: 'Premium',
  phone: '+1 (555) 012-4471',
  location: 'Austin, TX',
};

export const notifications = [
  { id: 1, title: 'Contribution received', detail: 'Payroll contribution of $320.50 was deposited.', time: '2h ago' },
  { id: 2, title: 'Goal milestone reached', detail: "You're 59% of the way to your retirement goal.", time: '1d ago' },
  { id: 3, title: 'New 401(k) rules', detail: 'Regulatory changes may affect your contribution limits.', time: '3d ago' },
];
